// extracted by mini-css-extract-plugin
export default {"separator":"modalSeparator_separator__N1znM"};